import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Home from "./../components/icons/Home.vue";
import SmallHome from "./../components/icons/SmallHome.vue";
import NewInvoice from "./../components/icons/NewInvoice.vue";
import Products from "./../components/icons/Products.vue";
import SalesInvoice from "./../components/icons/SalesInvoice.vue";
import Chart from "./../components/icons/Chart.vue";
import Chart2 from "./../components/icons/Chart2.vue";
import Customer from "./../components/icons/Customer.vue";
import LargeCustomer from "./../components/icons/LargeCustomer.vue";
import Key from "./../components/icons/Key.vue";
import Warehouse from "./../components/icons/Warehouse.vue";
import Wallet from "./../components/icons/Wallet.vue";
import Box from "./../components/icons/Box.vue";
import BoxChecked from "./../components/icons/BoxChecked.vue";
import FinishedBox from "./../components/icons/FinishedBox.vue";
import ArrowDown from "./../components/icons/ArrowDown.vue";
import ArrowLeft from "./../components/icons/ArrowLeft.vue";
import ArrowRight from "./../components/icons/ArrowRight.vue";
import ChevronTop from "./../components/icons/ChevronTop.vue";
import ChevronLeft from "./../components/icons/ChevronLeft.vue";
import ChevronRight from "./../components/icons/ChevronRight.vue";
import Search from "./../components/icons/Search.vue";
import Close from "./../components/icons/Close.vue";
import Delete from "./../components/icons/Delete.vue";
import Bag from "./../components/icons/Bag.vue";
import Bag2 from "./../components/icons/Bag2.vue";
import Filter from "./../components/icons/Filter.vue";
import Phone from "./../components/icons/Phone.vue";
import SmallPhone from "./../components/icons/SmallPhone.vue";
import Email from "./../components/icons/Email.vue";
import Pet from "./../components/icons/Pet.vue";
import PetSmall from "./../components/icons/PetSmall.vue";
import BorderedKey from "./../components/icons/BorderedKey.vue";
import EyeOff from "./../components/icons/EyeOff.vue";
import EyeOn from "./../components/icons/EyeOn.vue";
import BorderedCheck from "./../components/icons/BorderedCheck.vue";
import Logout from "./../components/icons/Logout.vue";
import Calendar from "./../components/icons/Calendar.vue";
import TrendUp from "./../components/icons/TrendUp.vue";
import TrendDown from "./../components/icons/TrendDown.vue";
import BorderedPhone from "./../components/icons/BorderedPhone.vue";
import Star from "./../components/icons/Star.vue";
import Cog from "./../components/icons/Cog.vue";
import Edit from "./../components/icons/Edit.vue";
import PurpleChecked from "./../components/icons/PurpleChecked.vue";
import PurpleUnchecked from "./../components/icons/PurpleUnchecked.vue";
import Percent from "./../components/icons/Percent.vue";
import Location from "./../components/icons/Location.vue";
import Check from "./../components/icons/Check.vue";
import BoxEmpty from "./../components/icons/BoxEmpty.vue";
import BoxChecked2 from "./../components/icons/BoxChecked2.vue";
import StarFilled from "./../components/icons/StarFilled.vue";
import ShopCart from "./../components/icons/ShopCart.vue";
import ShopCart2 from "./../components/icons/ShopCart2.vue";
import Login from "./../components/icons/Login.vue";
import LoginMobile from "./../components/icons/LoginMobile.vue";
import Category from "./../components/icons/Category.vue";
import Chat from "./../components/icons/Chat.vue";
import QuestionMessage from "./../components/icons/QuestionMessage.vue";
import User from "./../components/icons/User.vue";
import Instagram from "./../components/icons/Instagram.vue";
import CheckShield from "./../components/icons/CheckShield.vue";
import SmallShopCart from "./../components/icons/SmallShopCart.vue";
import BigUser from "./../components/icons/BigUser.vue";
import Truck from "./../components/icons/Truck.vue";
import Mobile from "./../components/icons/Mobile.vue";
import BlackLocation from "./../components/icons/BlackLocation.vue";
import BrandIcon from "./../components/icons/BrandIcon.vue";
import Heart from "./../components/icons/Heart.vue";
import FilledHeart from "./../components/icons/FilledHeart.vue";
import BlackHeart from "./../components/icons/BlackHeart.vue";
import Telegram from "./../components/icons/Telegram.vue";

Vue.use(Vuetify);

const opts = {};

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#7c4dff",
        secondary: "#151b5e",
        shopPrimary: "#a076f9",
        shoppurple: "#6200ea",
        shopSecondary: "#1A237E",
        shopDeeppurple: "#6200ea",
        mainFont: "#222732",
        adminPrimary: "#7e57c2",
        whitefont: "#fff",
        redfont:'#f3536e',

        // accent: "#82B1FF",
        // error: "#FF5252",
        // info: "#2196F3",
        // success: "#4CAF50",
        // warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "mdi",
    values: {
      Home: {
        component: Home,
      },
      SmallHome: {
        component: SmallHome,
      },
      NewInvoice: {
        component: NewInvoice,
      },
      Products: {
        component: Products,
      },
      SalesInvoice: {
        component: SalesInvoice,
      },
      Chart: {
        component: Chart,
      },
      Chart2: {
        component: Chart2,
      },
      Customer: {
        component: Customer,
      },
      LargeCustomer: {
        component: LargeCustomer,
      },
      Key: {
        component: Key,
      },
      Warehouse: {
        component: Warehouse,
      },
      Wallet: {
        component: Wallet,
      },
      Box: {
        component: Box,
      },
      BoxChecked: {
        component: BoxChecked,
      },
      FinishedBox: {
        component: FinishedBox,
      },
      ArrowDown: {
        component: ArrowDown,
      },
      ArrowLeft: {
        component: ArrowLeft,
      },
      ArrowRight: {
        component: ArrowRight,
      },
      ChevronTop: {
        component: ChevronTop,
      },
      ChevronLeft: {
        component: ChevronLeft,
      },
      ChevronRight: {
        component: ChevronRight,
      },
      Search: {
        component: Search,
      },
      Close: {
        component: Close,
      },
      Delete: {
        component: Delete,
      },
      Bag: {
        component: Bag,
      },
      Bag2: {
        component: Bag2,
      },
      Filter: {
        component: Filter,
      },
      Phone: {
        component: Phone,
      },
      SmallPhone: {
        component: SmallPhone,
      },
      Email: {
        component: Email,
      },
      Telegram: {
        component: Telegram,
      },
      Pet: {
        component: Pet,
      },
      PetSmall: {
        component: PetSmall,
      },
      BorderedKey: {
        component: BorderedKey,
      },
      EyeOff: {
        component: EyeOff,
      },
      EyeOn: {
        component: EyeOn,
      },
      BorderedCheck: {
        component: BorderedCheck,
      },
      Logout: {
        component: Logout,
      },
      Calendar: {
        component: Calendar,
      },
      TrendUp: {
        component: TrendUp,
      },
      TrendDown: {
        component: TrendDown,
      },
      BorderedPhone: {
        component: BorderedPhone,
      },
      Star: {
        component: Star,
      },
      Cog: {
        component: Cog,
      },
      Edit: {
        component: Edit,
      },
      PurpleChecked: {
        component: PurpleChecked,
      },
      PurpleUnchecked: {
        component: PurpleUnchecked,
      },
      Percent: {
        component: Percent,
      },
      Location: {
        component: Location,
      },
      Check: {
        component: Check,
      },
      BoxEmpty: {
        component: BoxEmpty,
      },
      BoxChecked2: {
        component: BoxChecked2,
      },
      ShopCart: {
        component: ShopCart,
      },
      ShopCart2: {
        component: ShopCart2,
      },
      Login: {
        component: Login,
      },
      LoginMobile: {
        component: LoginMobile,
      },
      Category: {
        component: Category,
      },
      Chat: {
        component: Chat,
      },
      QuestionMessage: {
        component: QuestionMessage,
      },
      User: {
        component: User,
      },
      Instagram: {
        component: Instagram,
      },
      CheckShield: {
        component: CheckShield,
      },
      SmallShopCart: {
        component: SmallShopCart,
      },
      BigUser: {
        component: BigUser,
      },
      Truck: {
        component: Truck,
      },
      Mobile: {
        component: Mobile,
      },
      BlackLocation: {
        component: BlackLocation,
      },
      BrandIcon: {
        component: BrandIcon,
      },
      Heart: {
        component: Heart,
      },
      FilledHeart: {
        component: FilledHeart,
      },
      BlackHeart: {
        component: BlackHeart,
      },
    },
  },
  rtl: true,
});
